import { render, staticRenderFns } from "./Price.vue?vue&type=template&id=9dc37a58&"
import script from "./Price.vue?vue&type=script&lang=js&"
export * from "./Price.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9dc37a58')) {
      api.createRecord('9dc37a58', component.options)
    } else {
      api.reload('9dc37a58', component.options)
    }
    module.hot.accept("./Price.vue?vue&type=template&id=9dc37a58&", function () {
      api.rerender('9dc37a58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sales/services/requests/add/Price.vue"
export default component.exports